import { createApi, BaseQueryFn } from "@reduxjs/toolkit/query/react";
import { API } from "aws-amplify";
import { GraphQLOptions, GraphQLResult } from "@aws-amplify/api-graphql";

// Types
import { SshAuditEventListItem, ResultList, ParamsList, ListSshKeySignedEventsResponse } from "../../types";
import { listSshKeySignedEvents } from "../../graphql/queries";

const graphqlBaseQuery: BaseQueryFn<GraphQLOptions> = async (options) => {
    try {
        const response = (await API.graphql(options)) as GraphQLResult;
        return { data: response };
    }
    catch (error) {
        return { error: { status: 500, data: error } };
    }
};

export const auditEntriesApi = createApi({
  reducerPath: "audit",
  baseQuery: graphqlBaseQuery,
  tagTypes: ["Audit"],
  endpoints: (builder) => ({
    listSshKeySignedEvents: builder.query<ResultList<SshAuditEventListItem>, ParamsList>({
      query: (variables: ParamsList) => { return { query: listSshKeySignedEvents, variables: variables } },
      providesTags: () => { return [{ type: "Audit" }] },
      transformResponse: (response: GraphQLResult<ListSshKeySignedEventsResponse>) => {
        return {
          payload: response.data.listSshKeySignedEvents.sshKeySignedEvents || [],
          nextToken: response.data.listSshKeySignedEvents.nextToken,
          previousToken: response.data.listSshKeySignedEvents.previousToken
        }
    }
    })
  }),
});

export const {
  useListSshKeySignedEventsQuery,
  useLazyListSshKeySignedEventsQuery
} = auditEntriesApi;
